import styled from 'styled-components';

type TNotificationSC = {
  type?: 'ERROR' | 'SUCCESS' | 'default';
};
export const NotificationSC = styled.div<TNotificationSC>`
  width: 100%;
  border-radius: 12px;
  background: #fff;
  padding: 8px 12px;
  box-shadow: 0 6px 15px 0 rgba(51, 61, 108, 0.15);

  .notification-header {
    display: flex;
    align-items: center;
  }

  h6 {
    font-size: 14px;
    line-height: 24px;
    font-weight: 800;
    margin-bottom: 0;
    color: ${({ type, theme }) => {
      if (type === 'default' || !type) {
        return theme.color.tint.action;
      } else if (type === 'ERROR') {
        return theme.color.tint.error;
      } else if (type === 'SUCCESS') {
        return theme.color.tint.success;
      }
    }};
  }

  p {
    font-size: 14px;
    line-height: 24px;
    font-weight: 600;
    margin-bottom: 0;
  }
`;
